var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBikeHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29386",
    "data-name": "Group 29386",
    transform: "translate(-288 -262.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(288 262.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_14_",
    "data-name": "svgexport-17 (14)",
    transform: "translate(306 271.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50064",
    "data-name": "Path 50064",
    d: "M1.59,96.5l-.142.145L0,98.337l.364.252,2.313-1.336Zm0,0",
    transform: "translate(0 -93.126)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50065",
    "data-name": "Path 50065",
    d: "M2.143,101.075l-1.01.616-.77.895L0,102.333l1.447-1.692Zm0,0",
    transform: "translate(0 -97.122)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50066",
    "data-name": "Path 50066",
    d: "M362.463,142.7a.386.386,0,0,1-.372-.284l-2.446-8.95a.386.386,0,1,1,.744-.2l2.446,8.95a.386.386,0,0,1-.27.474A.38.38,0,0,1,362.463,142.7Zm0,0",
    transform: "translate(-347.056 -128.333)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50067",
    "data-name": "Path 50067",
    d: "M35.83,96.059a1.412,1.412,0,0,0-1.51-.09l-1.035.588a1.9,1.9,0,0,0-.867,1.858,5.362,5.362,0,0,0,2.239,4.278,1.418,1.418,0,0,0,1.5.1l1.1-.62a1.943,1.943,0,0,0,.819-1.835A5.362,5.362,0,0,0,35.83,96.059Zm0,0",
    transform: "translate(-31.284 -92.441)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50068",
    "data-name": "Path 50068",
    d: "M36.9,119.325c0,1.649-1,2.406-2.239,1.692a5.362,5.362,0,0,1-2.239-4.278c0-1.649,1-2.406,2.239-1.693A5.362,5.362,0,0,1,36.9,119.325Zm0,0",
    transform: "translate(-31.284 -110.765)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50069",
    "data-name": "Path 50069",
    d: "M59.715,153.245c0,1.017-.618,1.484-1.381,1.044a3.307,3.307,0,0,1-1.381-2.638c0-1.017.618-1.484,1.381-1.044A3.307,3.307,0,0,1,59.715,153.245Zm0,0",
    transform: "translate(-54.962 -145.181)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50070",
    "data-name": "Path 50070",
    d: "M87.029,184.806l-4.308-2.488a.826.826,0,0,0-.8-.012.484.484,0,0,0-.4.477,1.313,1.313,0,0,0,.656,1.137l4.853,2.806Zm0,0",
    transform: "translate(-78.67 -175.837)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50071",
    "data-name": "Path 50071",
    d: "M152.223,155.047v1.384a.817.817,0,0,0,.408.707l1.52.878a1.362,1.362,0,0,1,.643,1.157v.722a1.246,1.246,0,0,0,.623,1.079l1.233.712a.472.472,0,0,0,.477,0l2.553-1.47.033-.019h0a.471.471,0,0,0,.222-.4,3.916,3.916,0,0,1,.216-1.282l.427-1.233Zm0,0",
    transform: "translate(-146.9 -149.625)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50072",
    "data-name": "Path 50072",
    d: "M85.921,166.762l-1.928-1.113v1.013a.817.817,0,0,0,.408.707l1.52.878Zm1.909,2.848-5.582-3.227a.485.485,0,0,0-.727.42,1.313,1.313,0,0,0,.656,1.137l5.654,3.268Zm0,0",
    transform: "translate(-78.669 -159.856)",
    fill: "#525e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50073",
    "data-name": "Path 50073",
    d: "M29.345,2.094l-.371-.643A2.025,2.025,0,0,0,28.232.71L27.163.093a.683.683,0,0,0-.75.041l-2.471,1.4a.683.683,0,0,0-.4.626,1.792,1.792,0,0,0,.9,1.552l4.246,2.452L31.877,3.6Zm0,0",
    transform: "translate(-22.717 0)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50074",
    "data-name": "Path 50074",
    d: "M29.285,45.659l-2.532-1.51-.372-.643a2.025,2.025,0,0,0-.741-.741l-1.069-.617a.688.688,0,0,0-1.032.6,1.792,1.792,0,0,0,.9,1.552l4.246,2.452Zm0,0",
    transform: "translate(-22.716 -40.584)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50075",
    "data-name": "Path 50075",
    d: "M115.457,61.381l2.591-1.471,2.532,1.51-2.591,1.471Zm0,0",
    transform: "translate(-111.42 -57.815)",
    fill: "#525e65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50076",
    "data-name": "Path 50076",
    d: "M176.559,93.307a2.832,2.832,0,0,0-2.857-.015l-2.477,1.437-.095.052a1.052,1.052,0,0,0-.526.911v.135l5.142,2.969,2.571-1.489v-.929a3.56,3.56,0,0,0-1.76-3.071Zm0,0",
    transform: "translate(-164.639 -89.664)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50077",
    "data-name": "Path 50077",
    d: "M170.6,136.925l5.142,2.969v-.929a3.56,3.56,0,0,0-1.76-3.071,2.831,2.831,0,0,0-2.856-.015,1.052,1.052,0,0,0-.526.911Zm0,0",
    transform: "translate(-164.639 -130.762)",
    fill: "#872e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50078",
    "data-name": "Path 50078",
    d: "M207.371,197.492l3.857,2.227-.427,1.233a3.918,3.918,0,0,0-.216,1.282.477.477,0,0,1-.715.413l-1.233-.712a1.246,1.246,0,0,1-.623-1.079v-.722a1.362,1.362,0,0,0-.643-1.157Zm0,0",
    transform: "translate(-200.12 -190.586)",
    fill: "#82a5b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50079",
    "data-name": "Path 50079",
    d: "M345.077,307.177a1.412,1.412,0,0,0-1.51-.09l-1.035.588a1.9,1.9,0,0,0-.866,1.858,5.362,5.362,0,0,0,2.239,4.278,1.418,1.418,0,0,0,1.5.1l1.1-.62a1.943,1.943,0,0,0,.819-1.835A5.361,5.361,0,0,0,345.077,307.177Zm0,0",
    transform: "translate(-329.718 -296.177)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50080",
    "data-name": "Path 50080",
    d: "M334.589,289.572a1.583,1.583,0,0,0-1.774-.065l-1.356.783a2.216,2.216,0,0,0-.927,2.086,6.137,6.137,0,0,0,.557,2.44l.154-.075a.758.758,0,0,0,.4-.885,3.455,3.455,0,0,1-.132-.916c0-1.157.7-1.689,1.571-1.188a2.343,2.343,0,0,1,.5.4.635.635,0,0,0,.941-.047l.082-.1.942-.548a.645.645,0,0,0,.487-.232l.082-.1A4.675,4.675,0,0,0,334.589,289.572Zm0,0",
    transform: "translate(-318.973 -279.152)",
    fill: "#e33400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50081",
    "data-name": "Path 50081",
    d: "M346.142,330.444c0,1.649-1,2.406-2.239,1.693a5.362,5.362,0,0,1-2.239-4.278c0-1.649,1-2.406,2.239-1.692A5.361,5.361,0,0,1,346.142,330.444Zm0,0",
    transform: "translate(-329.717 -314.502)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50082",
    "data-name": "Path 50082",
    d: "M368.965,364.363c0,1.017-.618,1.484-1.381,1.044a3.307,3.307,0,0,1-1.381-2.638c0-1.017.618-1.484,1.381-1.044A3.307,3.307,0,0,1,368.965,364.363Zm0,0",
    transform: "translate(-353.398 -348.916)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50083",
    "data-name": "Path 50083",
    d: "M389.811,395.349c0,.44-.267.642-.6.451a1.43,1.43,0,0,1-.6-1.141c0-.44.267-.642.6-.451A1.43,1.43,0,0,1,389.811,395.349Zm0,0",
    transform: "translate(-375.028 -380.354)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50084",
    "data-name": "Path 50084",
    d: "M331.507,317.181c0-1.157.7-1.689,1.571-1.188a2.341,2.341,0,0,1,.5.4.635.635,0,0,0,.941-.047l.082-.1a4.674,4.674,0,0,0-1.527-1.559c-1.407-.812-2.547.05-2.547,1.926a6.137,6.137,0,0,0,.557,2.44l.154-.075a.758.758,0,0,0,.4-.885,3.455,3.455,0,0,1-.132-.916Zm0,0",
    transform: "translate(-318.973 -303.393)",
    fill: "#872e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50085",
    "data-name": "Path 50085",
    d: "M326.739,164.338a.386.386,0,0,1-.372-.284l-2.446-8.95a.386.386,0,1,1,.744-.2l2.446,8.95a.386.386,0,0,1-.372.487Zm0,0",
    transform: "translate(-312.581 -149.21)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50086",
    "data-name": "Path 50086",
    d: "M362.176,22.438a.386.386,0,0,1-.193-.72l.991-.572a.386.386,0,1,1,.386.668l-.991.572A.384.384,0,0,1,362.176,22.438Zm0,0",
    transform: "translate(-349.139 -20.356)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50087",
    "data-name": "Path 50087",
    d: "M373.79,44.318h-1.282a.208.208,0,1,1,0-.416h1.282a.208.208,0,0,1,0,.416Zm0,0",
    transform: "translate(-359.282 -42.367)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50088",
    "data-name": "Path 50088",
    d: "M236.168,42.554a2.028,2.028,0,0,1-1.451-.61l-1.2-1.224a.386.386,0,0,1,.551-.54l1.2,1.224a1.258,1.258,0,0,0,1.528.21l1.227-.708a.738.738,0,0,0,.353-.8l-.47-2.182a.386.386,0,1,1,.754-.162l.47,2.181a1.507,1.507,0,0,1-.722,1.627l-1.227.708A2.024,2.024,0,0,1,236.168,42.554Zm0,0",
    transform: "translate(-225.247 -36.151)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50089",
    "data-name": "Path 50089",
    d: "M197.324,113.438a.386.386,0,0,1-.193-.72l1.275-.736a.386.386,0,0,1,.386.668l-1.275.736A.383.383,0,0,1,197.324,113.438Zm0,0",
    transform: "translate(-190.052 -108.016)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50090",
    "data-name": "Path 50090",
    d: "M320.052,119.493l-.662-.382a2.025,2.025,0,0,0-2.025,0,1.732,1.732,0,0,0,0,3l1.188.7a.746.746,0,0,0,.808-.043,2.847,2.847,0,0,0,1.189-2.272C320.55,119.963,320.353,119.606,320.052,119.493Zm0,0",
    transform: "translate(-305.432 -114.684)",
    fill: "#82a5b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50091",
    "data-name": "Path 50091",
    d: "M366.73,137.449a2.848,2.848,0,0,1-1.189,2.272c-.657.379-1.189-.023-1.189-.9a2.847,2.847,0,0,1,1.189-2.272c.657-.379,1.189.023,1.189.9Zm0,0",
    transform: "translate(-351.612 -131.638)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50092",
    "data-name": "Path 50092",
    d: "M247.454,151.525a2.018,2.018,0,0,1-.843,1.611c-.465.269-.843-.017-.843-.637a2.019,2.019,0,0,1,.843-1.611C247.077,150.619,247.454,150.9,247.454,151.525Zm-6.341,4a1.745,1.745,0,0,0,.729,1.393c.4.232.729-.014.729-.551a1.746,1.746,0,0,0-.729-1.393C241.439,154.746,241.113,154.993,241.113,155.53Zm0,0",
    transform: "translate(-232.682 -145.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50093",
    "data-name": "Path 50093",
    d: "M233.324,123.084a.2.2,0,0,1-.048-.006.208.208,0,0,1-.155-.25l.333-1.422a.208.208,0,1,1,.405.095l-.333,1.422A.208.208,0,0,1,233.324,123.084Zm0,0",
    transform: "translate(-224.964 -117.006)",
    fill: "#2e373d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeHighlighted);
export default __webpack_public_path__ + "static/media/BikeHighlighted.a319ee81a537280549dbe97cf7ce452f.svg";
export { ForwardRef as ReactComponent };